import React from 'react';
import { Facebook } from 'lucide-react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header className="border-b border-gray-200 bg-white sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-6">
            {/* VideBits Logo */}
            <a href="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity cursor-pointer">
              <img 
                src="/logo-transparent.svg" 
                alt="VideBits Logo" 
                className="w-8 h-8"
              />
              <h1 className="text-xl font-light text-gray-900">VideBits</h1>
            </a>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-videbits-500 shadow-2xl rounded-lg text-center px-6 py-12">
            <div className="mb-4">
              <h1 className="text-2xl text-white mb-6">Terms of Service</h1>
              
              <div className="text-base px-6 text-videbits-100 text-left space-y-4">
                <p>
                  <strong>1. Terms:</strong> By accessing the VideBits website, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. The materials contained in this website are protected by applicable copyright and trademark law.
                </p>
                
                <p>
                  <strong>2. Use License:</strong> Permission is granted to temporarily use the website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.
                </p>
                
                <p>
                  <strong>3. Disclaimer:</strong> The materials on the VideBits website are provided on an 'as is' basis. VideBits makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
                </p>
                
                <p>
                  <strong>4. Limitations:</strong> In no event shall VideBits or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on the VideBits website.
                </p>
                
                <p>
                  <strong>5. Accuracy of materials:</strong> The materials appearing on the VideBits website could include technical, typographical, or photographic errors. VideBits does not warrant that any of the materials on its website are accurate, complete, or current.
                </p>
                
                <p>
                  <strong>6. Links:</strong> VideBits has not reviewed all of the sites linked to our website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by VideBits of the site.
                </p>
                
                <p>
                  <strong>7. Modifications:</strong> VideBits may revise these terms of service at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.
                </p>
                
                <p>
                  <strong>8. Governing Law:</strong> These terms and conditions are governed by and construed in accordance with the laws of the United Kingdom and you irrevocably submit to the exclusive jurisdiction of the courts in that state or location.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 py-3">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-1 md:space-y-0">
            <div className="flex items-center space-x-6 text-sm text-gray-600">
              <a href="/about" className="hover:underline">About</a>
              <a href="/privacy" className="hover:underline">Privacy</a>
              <a href="/terms" className="hover:underline">Terms</a>
              <a href="/help" className="hover:underline">Help</a>
            </div>
            <div className="flex items-center space-x-4 text-xs text-gray-500">
              <a
                href="https://www.facebook.com/videbits"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="VideBits on Facebook"
                className="hover:text-gray-900 transition-colors"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <span>© {new Date().getFullYear()} VideBits Ltd</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Terms;